module.exports = __webpack_public_path__ + "img/earmuffs.83ddac88.jpg";